import * as modal from "../util/modal.ts";

import {FilerTreeCache} from "../server/objects/FilerBeans.ts"
import { FolderBean } from "../server/fizapilib.auto.ts";
import { protoExtend } from "../lib/ObjectUtil.ts";

type PickFolderOptions = {
  title:string,
  canPickRoot?:boolean
}

export async function pickFolder(options :PickFolderOptions) : Promise<FolderBean>{
  await FilerTreeCache.need();
  const
    folderPickerWidget = {
      initDom(element :HTMLElement){
        var
          value :string,
          valueNodes = element.querySelectorAll<HTMLElement>('[data-value]'),
          button = element.querySelector("button[data-fw-onclick='modalanswer']");


        function refresh(){
          valueNodes.forEach((node)=>{
            var
              valueOfNode = node.getAttribute('data-value'),
              icon = node.querySelector<HTMLElement>('icon.selectedinfo');

            if(valueOfNode===value){
              icon.style.visibility = 'visible';
              button.setAttribute('data-fw-onclick','modalanswer|'+value);
            } else{
              icon.style.visibility = 'hidden';
            }
          })
          if(value===undefined){
            button.setAttribute('disabled','disabled')
          }else{
            button.removeAttribute('disabled')
          }
        }
        valueNodes.forEach((node)=>{
          node.style.cursor='pointer'
          node.addEventListener('click',()=>{
            value = node.getAttribute('data-value')
            refresh()
          })
        })
        refresh()
      }
    };

  var root : FolderBean = FilerTreeCache.getRoot();
  var position = root;
  while(true){
    let isRoot = position===root;
    let datas = {
      isRoot,
      canPick:!isRoot||options.canPickRoot,
      title:options.title,
      position
    }


    var answer = await modal.askAsPromiseTpl(await import('./folderpicker.mustache'),datas,
      folderPickerWidget
    ) as string;
    if(answer==undefined) return;
    if(answer.indexOf('nav')!==0) return FilerTreeCache.get(answer) as FolderBean;
    position = FilerTreeCache.get(answer.substring(3)) as FolderBean
  }
}


type PickFileOptions = {
  title:string
}

export async function pickFile(options : PickFileOptions){
  await FilerTreeCache.need();

  var position : FolderBean = FilerTreeCache.getRoot();

  while(true){
    var metaId = await modal.askAsPromiseTpl(await import('./filepicker.mustache'),protoExtend(position,{
      title:options.title,
    })) as string;
    if(metaId==undefined) return;
    if(metaId.indexOf('nav')!==0) {
      return FilerTreeCache.get(metaId) as IMedia;
    }
    position = FilerTreeCache.get(metaId.substring(3)) as FolderBean
  }
}


